import { render, staticRenderFns } from "./openList.vue?vue&type=template&id=b13f123e&scoped=true"
import script from "./openList.vue?vue&type=script&lang=js"
export * from "./openList.vue?vue&type=script&lang=js"
import style0 from "./openList.vue?vue&type=style&index=0&id=b13f123e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13f123e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Maintenance projects\\devConfig-web-project\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b13f123e')) {
      api.createRecord('b13f123e', component.options)
    } else {
      api.reload('b13f123e', component.options)
    }
    module.hot.accept("./openList.vue?vue&type=template&id=b13f123e&scoped=true", function () {
      api.rerender('b13f123e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/openConfig/openList.vue"
export default component.exports